import { isMatchingMedia } from './helpers';

export const BURGER_TIME_OUT = 400;

export const burgerMenu = {
  isMobile() {
    return isMatchingMedia('(max-width:768px)');
  },
  init() {
    this.documentBody = document.querySelector('body');
    this.logoutButton = document.querySelector('#burger-menu-logout');
    this.closeBurgerButton = document.querySelector('.js-close-burger-menu');
    this.burgerCheckButton = document.querySelector('#burger-toggle');
    this.loginButton = document.querySelector('#burger-menu-login');

    this.changeLoginButtonText();
    this.handleLogoutButtonClick();
    this.handleCloseButtonClick();
    this.handleChangeEvent();
  },
  logout() {
    localStorage.removeItem('__cid');
    localStorage.removeItem('__eid');
    localStorage.removeItem('__ph');
    store.remove('answers');
    store.remove('isLoggedIn');
    document.getElementById('logout-form').submit();
  },
  changeLoginButtonText() {
    if (!this.loginButton || !store.get('isLoggedIn')) return;
    this.loginButton.textContent = backEndVars.tm237;
    this.loginButton.dataset.e2e = 'burger-menu-meal-plan';
  },
  handleCloseButtonClick() {
    this.closeBurgerButton.addEventListener('click', () => {
      this.burgerCheckButton.click();
      this.documentBody.classList.remove('noscroll', 'overflow-hidden', 'fixed-content');
    });
  },
  handleLogoutButtonClick() {
    this.logoutButton && this.logoutButton.addEventListener('click', this.logout);
  },
  handleChangeEvent() {
    this.burgerCheckButton.addEventListener('change', e => {
      e.currentTarget.checked &&
        this.isMobile() &&
        this.documentBody.classList.add('noscroll', 'overflow-hidden', 'fixed-content');
      this.burgerCheckButton.disabled = true;
      setTimeout(() => {
        this.burgerCheckButton.disabled = false;
      }, BURGER_TIME_OUT);
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  burgerMenu.init();
});
